export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_01.4ead2fa2.jpg";